<template>
  <transition-group name='fade'>
    <!-- 蒙版 -->
    <div class="mask"
         key="1"
         @click="show = false"
         v-if="show"
         @touchmove.prevent>
    </div>
    <div class="pop"
         v-show="show"
         key="2">
      <div class="bg">
        <img src="https://img.webloom.cn/img/3b78fc44eaa7aec0dd7c37f8bcd777b7.png" alt="" class="start">
        <div class="title">恭喜获得证书</div>
        <img src="https://img.webloom.cn/img/e9d698bb89f67ff99e2c746b85832f33.png" alt="" style="position: absolute; top: 120px; left: 74px">
        <img src="https://img.webloom.cn/img/00c19cbb3305e5dfd469ed98368679eb.png" alt="" style="position: absolute; top: 120px; right: 74px">
<!--        <div class="nameBox">-->
<!--          <div class="main" v-if="content.length > 1">-->
<!--            <div class="item" style="overflow: hidden;height: 20px;white-space: nowrap;text-overflow: ellipsis">{{content[0]}}</div>-->
<!--            <div class="item" style="overflow: hidden;height: 20px;white-space: nowrap;text-overflow: ellipsis">{{content[1]}}</div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <div style="width: 215px; overflow: hidden;height: 20px;white-space: nowrap;text-overflow: ellipsis">{{content[0]}}</div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="img_box">
          <div class="mainImg" v-if="imgUrl.length > 1">
            <img :src="imgUrl[0]" alt="" class="img">
            <img :src="imgUrl[1]" alt="" class="img">
          </div>
          <div class="mainImg" style="justify-content: center" v-else>
            <img :src="imgUrl[0]" alt="" class="img">
          </div>
        </div>
        <div class="btnbox cursor">
          <div class="btn" @click="btnClick">前往查看</div>
        </div>
      </div>
      <img @click="show = false"
           class="close cursor"
           src="https://img.webloom.cn/coach/ui/common_close_white.png"
           alt="">
    </div>
  </transition-group>

</template>

<script>
export default {
  name: 'Popup',
  data () {
    return {
      show: false,
      imgUrl: '',
      title: '',
      content: '',
      btnText: ''
    }
  },
  created () {},
  methods: {
    btnClick () {
      this.click()
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
  background: url("https://img.webloom.cn/img/5a6d736e67ef057f273b0e1dedf9af0f.png") no-repeat center 10px;
  height: 600px;
  width: 690px;
  border-radius: 16px;
  position: relative;
  .title{
    font-family: SourceHanSansCN-Heavy;
    font-size: 40px;
    color: #F37544;
    letter-spacing: 0;
    font-weight: 600;
    position: absolute;
    left: 225px;
    top: 116px;
  }
  .start {
    display: block;
    position: absolute;
    top: 58px;
    left: 74px;
  }
}
// 渐变过渡
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s;
}
// 全局弹窗
.mask {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
}
.pop {
  height: 600px;
  width: 690px;
  //background:linear-gradient(0deg, #FA1A3A 0%, #FF9B5F 100%);
  border-radius: 16px;
  position: fixed;
  top: 100px;
  left: 50%;
  margin-left: -345px;
  z-index: 20;
  text-align: center;
  //background-color: linear-gradient(0deg, #FA1A3A 0%, #FF9B5F 100%);
  background:linear-gradient(0deg, #FA1A3A 0%, #FF9B5F 100%);
  .nameBox{
    margin-top: 128px;
    font-family: MicrosoftYaHeiUI-Bold;
    font-size: 20px;
    color: #FBD783;
    letter-spacing: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    .main{
      width: 455px;
      display: flex;
      justify-content: space-between;
      .item {
        width: 215px;
      }
    }
  }
  .img_box{
    width: 690px;
    position: absolute;
    bottom: 125px;
    //margin-top: 15px;
    height: 304px;
    display: flex;
    justify-content: center;
    .mainImg{
      display: flex;
      justify-content: space-between;
      width: 455px;
      align-items: center;
      .img{
        //height: 304px;
        width: 215px;
        background: #FFFFFF;
      }
    }
  }
  .btnbox{
    width: 690px;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 65px;
    .btn{
      border: 2px solid #F37544;
      //border: 2px solid #FBD783;
      border-radius: 8px;
      width: 120px;
      height: 40px;
      line-height: 40px;
      font-family: MicrosoftYaHeiUI-Bold;
      font-size: 14px;
      color: #F37544;
      letter-spacing: 0;
      text-align: center;
      margin-top: 20px;
    }
  }
  button {
    background: #f95644;
    border-radius: 32px;
    width: 180px;
    height: 50px;
    font-size: 18px;
    color: #ffffff;
  }
  .close {
    top: -35px;
    right: 0px;
    position: absolute;
    display: block;
    width: 32px;
    height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/index.vue